export const DISABLE_BNPL_OFFERS = "DISABLE_BNPL_OFFERS";

export const futuresList = [
  {
    name: DISABLE_BNPL_OFFERS,
    isActive: true,
    description: "Disables BNPL offer",
  },
];
